<template>
  <div class="panel panel-default">
    <div
      class="panel-heading"
      role="button"
      @click="togglePassage()">
      <i class="fa pull-right fa-angle-down gbm-animated-icon" :class="{'gbm-animated-icon--upside-down': showPassage}"/>
      <b>Passage:</b> {{ passage.passage_title }}
    </div>
    <collapse v-model="showPassage">
      <div class="panel-body">
        <div class="passage">
          <markdown-text :text="passage.passage_text" :class="{'locked-region': locked}" />
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import MarkdownText from '@/components/MarkdownText'
export default {
  name: 'ItemPassage',
  props: {
    passage: {
      type: Object,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  components: { MarkdownText },
  data() {
    return {
      showPassage: true
    }
  },
  methods: {
    togglePassage() {
      this.showPassage = !this.showPassage
    }
  }
}
</script>

<style scoped>
.passage {
  font-family: 'Times', serif;
}
</style>
<style>
.passage img {
  max-width: 100%;
}
</style>
